import {
  ADD_USER_BY_ROLE,
  GET_ALL_USERS,
  GET_USERS_BY_ROLE,
  GET_ALL_USERS_TEST,
} from "../actions/action.types";

const initialState = {
  all: [],
  alltest: [],
  farmer: [],
  investors: [],
  mvps: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_USERS:
      return {
        ...state,
        all: action.payload,
      };
    case GET_ALL_USERS_TEST:
      return {
        ...state,
        alltest: action.payload,
      };
    case GET_USERS_BY_ROLE:
      return {
        ...state,
        [action.payload.role]: action.payload.data,
      };
    case ADD_USER_BY_ROLE:
      return {
        ...state,
        [action.payload.role]: [
          ...state[action.payload.role],
          ...action.payload.data,
        ],
      };
    default:
      return state;
  }
};

export default userReducer;
